import { render, staticRenderFns } from "./ControlsAFA.vue?vue&type=template&id=a841112a&scoped=true&"
import script from "./ControlsAFA.vue?vue&type=script&lang=js&"
export * from "./ControlsAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a841112a",
  null
  
)

export default component.exports